import React from 'react';

const SebraetecIcon = ({ size = 32, ...props }) => (
  <svg
    width={size}
    height={(size * 21) / 32}
    viewBox='0 0 32 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M22.1758 20.8295L26.8337 0.244797H21.6524L17.1219 20.8295H22.1758Z'
      fill='#0041D9'
    />
    <path
      d='M16.7279 0L15.8861 3.79016H31.1572L32 0H16.7279Z'
      fill='url(#sei-g0)'
    />
    <path
      d='M11.3327 15.1447L13.4382 5.66882H8.38434L6.2788 15.1447H11.3327Z'
      fill='#0041D9'
    />
    <path
      d='M0.842812 17.0403L2.40823e-09 20.8305H15.1229L15.9657 17.0403H0.842812Z'
      fill='url(#sei-g1)'
    />
    <path
      d='M18.5687 5.56433L17.7259 9.35549H7.61815L8.46096 5.56433H18.5687Z'
      fill='url(#sei-g2)'
    />
    <path
      d='M15.1229 20.8305L17.2294 11.3546H12.1755L10.069 20.8305H15.1229Z'
      fill='#0041D9'
    />
    <path
      d='M16.3866 15.1447L17.2294 11.3546H7.12162L6.2788 15.1447H16.3866Z'
      fill='#0041D9'
    />
    <defs>
      <linearGradient
        id='sei-g0'
        x1='15.8858'
        y1='-0.000298703'
        x2='31.9996'
        y2='-0.000298713'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#3B4AFF' />
        <stop offset='0.017' stopColor='#3B4AFF' />
        <stop offset='1' stopColor='#40BBFF' />
      </linearGradient>
      <linearGradient
        id='sei-g1'
        x1='0.000199011'
        y1='17.04'
        x2='15.9657'
        y2='17.04'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#3B4AFF' />
        <stop offset='0.017' stopColor='#3B4AFF' />
        <stop offset='1' stopColor='#40BBFF' />
      </linearGradient>
      <linearGradient
        id='sei-g2'
        x1='7.61825'
        y1='5.56453'
        x2='18.5685'
        y2='5.56453'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#3B4AFF' />
        <stop offset='0.017' stopColor='#3B4AFF' />
        <stop offset='1' stopColor='#40BBFF' />
      </linearGradient>
    </defs>
  </svg>
);

export default SebraetecIcon;
